export class ValidatePlanResponseModel {
    isValid;
    params;
}
//# sourceMappingURL=validate-plan-response.js.map